// extracted by mini-css-extract-plugin
export default {"text_splitter":"TextSplitter_text_splitter__mnM4j"};